import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItemIcon,
  MenuItem,
  MenuList,
} from '@mui/material';
import { Close as CloseIcon, Check as CheckIcon } from '@mui/icons-material';

import {
  adminUpdateInvoice,
  IInvoice,
} from '../../../../../../store/V2/InvoicesSlice';
import {
  invoiceStatusOptions,
  TInvoiceStatusOption,
} from '../../../../../../constants';

interface EditInvoiceStatusModalProps {
  open: boolean;
  onClose: () => void;
  invoice: IInvoice;
}

const EditInvoiceStatusModal: FunctionComponent<EditInvoiceStatusModalProps> = ({
  open,
  onClose,
  invoice,
}) => {
  const dispatch = useDispatch();

  // State
  const [
    selectedStatus,
    setSelectedStatus,
  ] = useState<TInvoiceStatusOption | null>(null);

  useEffect(() => {
    if (invoice) {
      const matchingStatus = invoiceStatusOptions.find(
        (item) => item.value === invoice.status
      );

      if (matchingStatus) {
        setSelectedStatus(matchingStatus);
      }
    }
  }, []);

  const handleStatusChange = (option: TInvoiceStatusOption) => {
    setSelectedStatus(option);

    dispatch(
      adminUpdateInvoice({
        id: invoice._id,
        status: option.value,
      })
    );

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: '20px', width: '100%', maxWidth: '320px' },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: { xs: '15px', sm: '30px' },
          color: '#000000',
          fontWeight: 600,
          fontSize: '16px',
        }}
      >
        Select Status
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: { xs: '7px', sm: '22px' },
          top: { xs: '7px', sm: '22px' },
        }}
      >
        <CloseIcon sx={{ color: '#000000' }} />
      </IconButton>
      <DialogContent
        sx={{ p: { xs: '0 15px 15px 15px', sm: '0 30px 30px 30px' } }}
      >
        <MenuList dense>
          {invoiceStatusOptions.map((item) => {
            const isSelected = Boolean(
              selectedStatus && selectedStatus.value === item.value
            );

            return (
              <MenuItem
                key={item.value}
                onClick={() => handleStatusChange(item)}
                sx={{ textTransform: 'capitalize' }}
              >
                {isSelected && (
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                )}
                {item.label.toLowerCase()}
              </MenuItem>
            );
          })}
        </MenuList>
      </DialogContent>
    </Dialog>
  );
};

export default EditInvoiceStatusModal;
